(function($) {

  $(document).ready(function() {

    var fastLink = $('.price-list__name-col--span');


    fastLink.click(function(event) {

      var fastLinkId = $(this).data('course-id');

      var e = $('.common-form ');
      scope = angular.element(e).scope();
      // update the model with a wrap in $apply(fn) which will refresh the view for us
      scope.$apply(function() {
        $scope.$broadcast('select-course-fp', fastLinkId);
      });

      $('html, body').animate({
        scrollTop: $(".action__form").offset().top - 30
      }, 1000);

    });


  });

})(jQuery);
